(function ($) {
  'use strict';

  const ITEM_ID = '10107815';
  const SHOP_BID = '203706';
  const VARIANT_ID = '555a00048';

  const BASE_IMG = 'https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/wb-router/';
  const BG_IMG = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/';
  const EXISTING_URL = 'https://interior-arne.com/products/';

  const LIMITS = {
    haba: { min: 30, max: 60, label: '幅' },
    depth: { min: 15, max: 24, label: '奥行' },
    height: { min: 25, max: 45, label: '高さ' }
  };

  const MATERIAL_TEXT = {
    wood: 'リーズナブル木目：<br>[材質]プリント化粧合板',
    aino: 'パステルカラーaino：<br>[材質]強化紙化粧合板',
    mela: 'ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)'
  };

  const COLOR_BAND = {
    A: ['wood', 'aino'],
    B: ['nail', 'bk', 'bp'],
    C: ['mb', 'gs', 'ww']
  };

  const ROW_BASE_BY_DEPTH = [
    { max: 15, A: 0, B: 7, C: 14 },
    { max: 20, A: 21, B: 28, C: 35 },
    { max: Infinity, A: 42, B: 49, C: 56 }
  ];

  let priceTable = null;
  let existingList = null;
  let detachedPanelOption1 = null;
  let initialColorApplied = false;

  function onlyDigits(v) {
    return String(v == null ? '' : v).replace(/[^\d]/g, '');
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    const isEmpty = cleaned === '';
    const val = isEmpty ? NaN : parseInt(cleaned, 10);
    return { el: el, val: val, isEmpty: isEmpty };
  }

  function ceil5(n) {
    return Math.ceil(n / 5) * 5;
  }

  function formatYen(n) {
    const s = String(n == null ? '' : n).replace(/[^\d]/g, '');
    if (!s) return '';
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '円';
  }

  function formatApprox(n) {
    if (!Number.isFinite(n)) return '';
    const rounded = Math.round(n * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 1e-9) return '約' + Math.round(rounded) + 'cm';
    return '約' + rounded.toFixed(1) + 'cm';
  }

  function normalizeColorToken() {
    const $checked = $('input[name="colortype1"]:checked');
    const dataType = String($checked.data('type') || '').toLowerCase();
    const id = String($checked.attr('id') || '').toLowerCase();
    const value = String($checked.val() || '');

    if (dataType === 'wood' || dataType === 'aino') return dataType;
    if (id.indexOf('mela_') === 0) return id.replace(/^mela_/, '');
    if (value) return value.toLowerCase();
    return '';
  }

  function existingColorKey() {
    const $checked = $('input[name="colortype1"]:checked');
    const dataType = String($checked.data('type') || '').toLowerCase();
    if (dataType === 'wood' || dataType === 'aino') return dataType;
    return String($checked.val() || '');
  }

  function getBandByColor() {
    const token = normalizeColorToken();
    if (COLOR_BAND.A.indexOf(token) !== -1) return 'A';
    if (COLOR_BAND.B.indexOf(token) !== -1) return 'B';
    if (COLOR_BAND.C.indexOf(token) !== -1) return 'C';
    return null;
  }

  function getSelectedColorName() {
    return $('input[name="colortype1"]:checked').val() || '';
  }

  function getSelectedColorId() {
    return $('input[name="colortype1"]:checked').attr('id') || '';
  }

  function getSelectedMaterialType() {
    return String($('input[name="colortype1"]:checked').data('type') || '').toLowerCase();
  }

  function getPanelCount() {
    const n = parseInt(String($('#panel').val() || '0'), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function getOpPanelCount() {
    const n = parseInt(onlyDigits($('.form_checkbox--num').val()), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function getTotalShelfCount() {
    return getPanelCount() + getOpPanelCount();
  }

  function getDowelLabel() {
    if (getOpPanelCount() > 0) return '有り';
    return getPanelCount() === 0 ? '無し' : '有り';
  }

  function $sizeMsg() {
    return $('.form_size').closest('.form').find('> .msg').first();
  }

  function $orderMsg() {
    return $('.order-summary > .msg');
  }

  function setCheckoutUIEnabled(on) {
    const price = document.querySelector('.check_price');
    const cart = document.querySelector('.cart--btn');
    if (price) price.setAttribute('style', on ? '' : 'visibility: hidden');
    if (cart) {
      if (on) cart.removeAttribute('disabled');
      else cart.setAttribute('disabled', '');
    }
  }

  function resetOrderSummary() {
    $orderMsg().empty();
    $('.check_area li span').text('');
    $('.check_price').empty();
    setCheckoutUIEnabled(false);
    $('#units').val('');
  }

  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-router_price.csv', dataType: 'text' }).then(function (text) {
      priceTable = $.csv.toArrays(text).map(function (row) {
        return row.map(function (v) {
          return parseInt(String(v).replace(/[^\d]/g, ''), 10);
        });
      });
      return priceTable;
    }).catch(function () {
      priceTable = [];
      return priceTable;
    });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-router_existing.csv', dataType: 'text' }).then(function (text) {
      existingList = $.csv.toArrays(text);
      return existingList;
    }).catch(function () {
      existingList = [];
      return existingList;
    });
  }

  function setBubbleBySelectedColor() {
    const type = getSelectedMaterialType();
    const text = MATERIAL_TEXT[type] || '選択してください';
    $('.material_bubble').html(text);
  }

  function syncDowelHole() {
    $('#dowel_hole').val(getDowelLabel());
  }

  function sanitizeExtraPanelInput() {
    const $num = $('.form_checkbox--num');
    const cleaned = onlyDigits($num.val()).slice(0, 1);
    if ($num.val() !== cleaned) $num.val(cleaned);
  }

  function updatePreviewImages() {
    const colorId = getSelectedColorId() || 'wood_br';
    const area1 = document.querySelector('.form_size--img img[name="area1"]');
    const area2 = document.querySelector('.form_size--img img[name="area2"]');
    const area3 = document.querySelector('.form_size--img img[name="area3"]');

    if (area1) area1.src = BASE_IMG + 'arrow.png';
    if (area2) {
      area2.src = BASE_IMG + 'panel/' + colorId + '.png';
      area2.style.visibility = (getPanelCount() === 1 || getOpPanelCount() > 0) ? 'visible' : 'hidden';
    }
    if (area3) area3.src = BASE_IMG + '401535/' + colorId + '.png';

    resizeFormSizeImages();
  }

  function updateExtraPanelFieldState() {
    const heightRec = readInt('height');
    const allow = !heightRec.isEmpty && Number.isFinite(heightRec.val) && heightRec.val >= 40;
    const $check = $('#op_panel');
    const $num = $('.form_checkbox--num');

    $check.prop('disabled', !allow);
    if (!allow) $check.prop('checked', false);

    if (allow && $check.prop('checked')) {
      $num.prop('disabled', false);
      $num.css({
        opacity: '1',
        background: '#fff',
        border: '1px solid #ccc',
        width: '50%',
        height: '2.5em'
      });
    } else {
      $num.val('');
      $num.prop('disabled', true);
      $num.removeAttr('style');
    }
    sanitizeExtraPanelInput();
    syncDowelHole();
    updatePreviewImages();
  }

  function updatePanelOptions() {
    const $panel = $('#panel');
    if (!$panel.length) return;

    if (!detachedPanelOption1) {
      const $opt1 = $panel.find('option[value="1"]');
      if ($opt1.length) detachedPanelOption1 = $opt1.clone();
    }

    const height = readInt('height').val;
    const has1 = $panel.find('option[value="1"]').length > 0;
    const allow1 = Number.isFinite(height) && height >= 40;

    if (allow1) {
      if (!has1 && detachedPanelOption1) $panel.append(detachedPanelOption1.clone());
    } else {
      if (String($panel.val()) === '1') $panel.val('0');
      $panel.find('option[value="1"]').remove();
    }

    syncDowelHole();
    updateExtraPanelFieldState();
  }

  function resizeFormSizeImages() {
    const $wrap = $('.form_size--img');
    if (!$wrap.length) return;
    const width = $wrap.width();
    let maxH = 0;

    $wrap.find('img').each(function () {
      if (width) $(this).css('width', width + 'px');
      const h = $(this).height();
      if (h > maxH) maxH = h;
    });

    if (maxH > 0) $wrap.height(maxH);
  }

  function bindResizeAfterLoad() {
    $('.form_size--img img').off('load.wbRouterResize').on('load.wbRouterResize', function () {
      resizeFormSizeImages();
    });
  }

  function calcInnerWidth(width, materialType) {
    if (!Number.isFinite(width)) return NaN;
    return materialType === 'mela' ? width - 3.4 : width - 3.6;
  }

  function calcInnerDepth(depth, materialType) {
    if (!Number.isFinite(depth)) return NaN;
    return materialType === 'mela' ? depth - 4.6 : depth - 4.8;
  }

  function calcInnerHeight(height, materialType) {
    if (!Number.isFinite(height)) return NaN;
    return materialType === 'mela' ? height - 8.5 : height - 8.7;
  }

  function updateInnerDisplayOne(key) {
    const materialType = getSelectedMaterialType() || 'wood';
    const rec = readInt(key);
    let value = NaN;
    let outId = '';
    let lim = null;

    if (key === 'haba') {
      value = calcInnerWidth(rec.val, materialType);
      outId = 'haba_id';
      lim = LIMITS.haba;
    } else if (key === 'depth') {
      value = calcInnerDepth(rec.val, materialType);
      outId = 'depth_id';
      lim = LIMITS.depth;
    } else if (key === 'height') {
      value = calcInnerHeight(rec.val, materialType);
      outId = 'height_id';
      lim = LIMITS.height;
    }

    if (!outId) return;

    if (rec.isEmpty || !Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      $('#' + outId).val('');
      return;
    }

    $('#' + outId).val(formatApprox(value));
  }

  function updateInnerDisplays() {
    updateInnerDisplayOne('haba');
    updateInnerDisplayOne('depth');
    updateInnerDisplayOne('height');
  }

  function removeSizeError(key) {
    $sizeMsg().find('.note-size-error[data-error-key="' + key + '"]').remove();
  }

  function setSizeError(key, text) {
    removeSizeError(key);
    if (!text) return;
    $sizeMsg().append($('<p class="note-size-error">').attr('data-error-key', key).text(text));
  }

  function validateSizeFieldForBlur(key) {
    const lim = LIMITS[key];
    if (!lim) return;
    const rec = readInt(key);
    if (rec.isEmpty) {
      removeSizeError(key);
      return;
    }
    if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      setSizeError(key, lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + (Number.isFinite(rec.val) ? rec.val : '') + 'cm）');
      return;
    }
    removeSizeError(key);
  }

  function buildJumpSizeErrors() {
    const errors = [];
    ['haba', 'depth', 'height'].forEach(function (key) {
      const lim = LIMITS[key];
      const rec = readInt(key);
      if (rec.isEmpty) {
        errors.push(lim.label + 'を入力してください');
      } else if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
        errors.push(lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + rec.val + 'cm）');
      }
    });
    return errors;
  }

  function findExistingCode(data) {
    if (!Array.isArray(existingList)) return null;
    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i] || [];
      const code = String(row[0] || '').trim();
      const w = parseInt(String(row[1] || '').replace(/[^\d]/g, ''), 10);
      const d = parseInt(String(row[2] || '').replace(/[^\d]/g, ''), 10);
      const h = parseInt(String(row[3] || '').replace(/[^\d]/g, ''), 10);
      const color = String(row[4] || '').trim();
      const totalShelf = parseInt(String(row[5] || '').replace(/[^\d]/g, ''), 10);

      if (!code) continue;
      if (
        w === data.haba &&
        d === data.depth &&
        h === data.height &&
        color.toLowerCase() === String(data.color).toLowerCase() &&
        totalShelf === data.totalShelf
      ) {
        return code;
      }
    }
    return null;
  }

  function setChoiceValues(data) {
    const choice1 = '幅：' + data.haba + 'cm/';
    const choice2 = '奥行：' + data.depth + 'cm/';
    const choice3 = '高さ：' + data.height + 'cm/';
    const choice4 = 'ダボ穴：' + data.dowel + '/';
    const choice5 = 'カラー：' + data.colorName + '/';
    const choice6 = '合計棚板枚数：' + data.totalShelf + '枚/';
    const choice7 = '見積もり金額：' + data.price;

    $('#choice1').val(choice1);
    $('#choice2').val(choice2);
    $('#choice3').val(choice3);
    $('#choice4').val(choice4);
    $('#choice5').val(choice5);
    $('#choice6').val(choice6);
    $('#choice7').val(choice7);
    $('#units').val(String(Math.round(data.price / 100)));
  }

  function buildEncodedChoice() {
    const lines = [
      $('#choice1').val(),
      $('#choice2').val(),
      $('#choice3').val(),
      $('#choice4').val(),
      $('#choice5').val(),
      $('#choice6').val(),
      $('#choice7').val()
    ].filter(function (v) {
      return String(v || '').length > 0;
    });

    const choice = lines.join('\r\n');
    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: 'EUCJP', from: 'UNICODE' });
    return Encoding.urlEncode(eucArray);
  }

  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    const units = $('#units').val();
    if (!units || !$('#choice1').val() || !$('#choice7').val()) return false;

    const encodedChoice = buildEncodedChoice();
    const existingForm = document.querySelector('form[name="cart_form_ori"]');
    if (existingForm) existingForm.remove();

    const form = document.createElement('form');
    form.method = 'post';
    form.name = 'cart_form_ori';
    form.action = 'https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set';
    form.acceptCharset = 'EUC-JP';
    form.target = '_blank';

    [
      { name: 'shop_bid', value: SHOP_BID },
      { name: 'item_id', value: ITEM_ID },
      { name: 'variant_id', value: VARIANT_ID },
      { name: 'units', value: units },
      { name: 'choice', value: encodedChoice }
    ].forEach(function (d) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = d.name;
      input.value = d.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    return false;
  }

  function rowBaseFor(depth, band) {
    for (let i = 0; i < ROW_BASE_BY_DEPTH.length; i++) {
      if (depth <= ROW_BASE_BY_DEPTH[i].max) return ROW_BASE_BY_DEPTH[i][band];
    }
    return NaN;
  }

  window.jump = function jump() {
    const $msg = $orderMsg();
    $msg.empty();

    const sizeErrors = buildJumpSizeErrors();
    const colorName = getSelectedColorName();
    const materialType = getSelectedMaterialType();
    const band = getBandByColor();

    if (sizeErrors.length) {
      sizeErrors.forEach(function (t) {
        $msg.append($('<p class="note-submit-error">').text(t));
      });
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    if (!colorName || !materialType || !band) {
      $msg.append($('<p class="note-submit-error">').text('カラーを選択してください'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    if (!Array.isArray(priceTable) || !priceTable.length) {
      $msg.append($('<p class="note-submit-error">').text('価格表の読み込みに失敗しました'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    const haba = readInt('haba').val;
    const depth = readInt('depth').val;
    const height = readInt('height').val;
    const width5 = ceil5(haba);
    const height5 = ceil5(height);
    const row = rowBaseFor(depth, band) + Math.round((width5 - 30) / 5);
    const col = Math.round((height5 - 25) / 5);
    const basePrice = priceTable[row] && priceTable[row][col];

    if (!Number.isFinite(basePrice)) {
      $msg.append($('<p class="note-submit-error">').text('価格が見つかりませんでした'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    const totalShelf = getTotalShelfCount();
    const dowel = getDowelLabel();

    const existingCode = findExistingCode({
      haba: haba,
      depth: depth,
      height: height,
      totalShelf: totalShelf,
      color: existingColorKey()
    });

    if (existingCode) {
      $msg.append(
        '<p class="existing-link">' +
          '<a href="' + EXISTING_URL + existingCode + '" target="_blank">' +
            '→既製品ページがございます。こちらのページよりお買い求めください。' +
          '</a>' +
        '</p>'
      );
      $('.check_price').empty();
      setCheckoutUIEnabled(false);
      $('#units').val('');
      return false;
    }

    let price = basePrice;
    if (materialType === 'aino') price += 1000;
    price += totalShelf * 500;

    const spans = document.querySelectorAll('.check_area ul li span');
    if (spans.length >= 6) {
      spans[0].textContent = haba;
      spans[1].textContent = depth;
      spans[2].textContent = height;
      spans[3].textContent = dowel;
      spans[4].textContent = colorName;
      spans[5].textContent = totalShelf;
    }

    setChoiceValues({
      haba: haba,
      depth: depth,
      height: height,
      dowel: dowel,
      colorName: colorName,
      totalShelf: totalShelf,
      price: price
    });

    $('.check_price').text(formatYen(price)).attr('style', '');
    $msg.append('<p class="note-submit-ok">以下の内容を確認し、買い物かごにお進みください。</p>');
    setCheckoutUIEnabled(true);
    return false;
  };

  window.checkBtn = function () { return true; };
  window.op_paneltext = function () { updateExtraPanelFieldState(); return true; };
  window.op_panelchange = function () { sanitizeExtraPanelInput(); syncDowelHole(); updatePreviewImages(); return true; };

  $(function () {
    loadPriceOnce();
    loadExistingOnce();
    bindResizeAfterLoad();

    if (!initialColorApplied && !$('input[name="colortype1"]:checked').length) {
      $('#wood_br').prop('checked', true);
      initialColorApplied = true;
    }

    setBubbleBySelectedColor();
    updatePanelOptions();
    updateExtraPanelFieldState();
    updateInnerDisplays();
    updatePreviewImages();
    resizeFormSizeImages();
    resetOrderSummary();

    $(window).on('resize', resizeFormSizeImages);
    $(window).on('pageshow', function () {
      updatePanelOptions();
      updateExtraPanelFieldState();
      updateInnerDisplays();
      updatePreviewImages();
      resizeFormSizeImages();
    });

    $(document).on('change', 'input[name="colortype1"]', function () {
      if (!this.checked) return;
      setBubbleBySelectedColor();
      updateInnerDisplays();
      updatePreviewImages();
    });

    $(document).on('input', '#haba, #depth, #height', function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
      updateInnerDisplayOne(this.id);
      if (this.id === 'height') updatePanelOptions();
      else updatePreviewImages();
    });

    $(document).on('change', '#height', function () {
      updatePanelOptions();
    });

    $(document).on('blur', '#haba, #depth, #height', function () {
      validateSizeFieldForBlur(this.id);
    });

    $(document).on('change', '#panel', function () {
      syncDowelHole();
      updatePreviewImages();
    });

    $(document).on('change', '#op_panel', function () {
      updateExtraPanelFieldState();
    });

    $(document).on('input', '.form_checkbox--num', function () {
      sanitizeExtraPanelInput();
      syncDowelHole();
      updatePreviewImages();
    });

    $('form[name="frm_detail"]').on('change input', 'input, select, textarea', function () {
      const $t = $(this);
      if ($t.is('#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7')) return;
      resetOrderSummary();
    });

    $(document).on('click', '#modal-cart', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('click', '.btn-cart, .cartadd', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('submit', 'form[name="frm_detail"]', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('submit', 'form[name="frm"]', function (e) {
      submitToRakutenCart(e);
    });
  });

})(jQuery);
